import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { FlashTradePerpsPoolResponse } from "@bridgesplit/abf-sdk";

const SWAP_QUOTE_TAG = "SWAP_QUOTE_TAG";
export const jupiterApi = createApi({
    reducerPath: "jupiterApi",
    tagTypes: [SWAP_QUOTE_TAG],
    baseQuery: fetchBaseQuery({ baseUrl: "" }),
    endpoints: (builder) => ({
        flashPerps: builder.query<FlashTradePerpsPoolResponse, void>({
            providesTags: [SWAP_QUOTE_TAG],
            query: () => ({
                url: "https://api.prod.flash.trade/earn-page/data",
                method: "GET"
            })
        })
    })
});

export const { useFlashPerpsQuery } = jupiterApi;
